import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-shuliang",
  "use": "icon-shuliang-usage",
  "viewBox": "0 0 1150 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1150 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-shuliang\"><defs><style type=\"text/css\"></style></defs><path d=\"M575.213163 570.785185a37.925926 37.925926 0 0 1-15.865679-3.476543l-537.28395-247.466667a37.925926 37.925926 0 0 1 0-68.898765l537.28395-247.466667a37.925926 37.925926 0 0 1 31.604939 0l537.28395 247.466667a37.925926 37.925926 0 0 1 0 68.898765l-537.28395 247.466667a37.925926 37.925926 0 0 1-15.73926 3.476543zM128.572176 285.392593L575.213163 491.077531l446.640988-205.684938L575.213163 79.707654zM1093.534151 705.548642l-518.320988 238.743704-518.320987-238.743704v83.500247l502.455308 231.474568a37.925926 37.925926 0 0 0 31.604939 0L1093.534151 789.048889z\" p-id=\"1491\" /><path d=\"M1093.534151 478.688395l-518.320988 238.806914L56.892176 478.688395V562.567901l502.455308 231.411358a37.925926 37.925926 0 0 0 31.604939 0L1093.534151 562.567901z\" p-id=\"1492\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/shuliang.svg
// module id = vUSo
// module chunks = 50